import { axiosInstance } from 'services/axiosConfig';

export class BaseAPI {
  constructor() {
    this.axios = axiosInstance;
  }
}
